import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route } from 'react-router-dom'
import { Switch } from 'react-router'
import Actions from '../../../actions'
import ListView from '../../common/ListView'
import dayjs from 'dayjs'
import $t from '../../../i18n'
import { useRouteMatch } from 'react-router'
import PastVisit from './PastVisit'
import FilePreviewPage from '../FilePreviewPage'
import { VISIT_SUMMARY_FLAG, clinicTypes } from '../../../consts'
import Page from '../../common/Page'

import './PastVisits.css'

const PastVisits = () => {
  const dispatch = useDispatch()
  const { path, url } = useRouteMatch()
  const selectedMemberId = useSelector(
    state => state.account?.selectedMember?.id
  )
  const pastVisits = useSelector(
    state => state.medicalInfo?.currentPastVisitsList
  )
  let arrayForSort = [...pastVisits]

  const sortPastVisitByDate = arrayForSort.sort((a, b) => {
    return new Date(b?.date) - new Date(a?.date)
  })

  const visitSummary = useSelector(state => state.medicalInfo?.visitSummary)
  const isLoading = useSelector(state => state.medicalInfo?.isLoadingDocs)

  const [pastVisitList, setPastVisitList] = useState([])

  useEffect(() => {
    dispatch(
      Actions.createAction(Actions.SET_PAST_VISITS_LIST, {
        id: selectedMemberId,
      })
    )
  }, [selectedMemberId])

  const getItemTitle = visit => {
    if (
      visit?.antidote_clinic?.includes(clinicTypes.PRIMARY) &&
      !visit?.is_created_by_patient
    ) {
      return $t('pages.waitingRoom.appointments.clinicianFollowup')
    }
    return $t('pages.waitingRoom.appointments.itemTitle')
  }

  useEffect(() => {
    const data = sortPastVisitByDate?.map(visit => {
      return {
        issueDate: dayjs(visit?.date).format('DD MMM YYYY h:mm A'),
        title: getItemTitle(visit),
        isFollowUp: !!visit.is_clinic_follow_up,
        antidote_clinic: visit.antidote_clinic,
        doctor: visit?.doctor?.speciality
          ? `Dr. ${visit?.doctor?.firstName} ${visit?.doctor?.lastName} | ${visit?.doctor?.speciality}`
          : `Dr. ${visit?.doctor?.firstName} ${visit?.doctor?.lastName}`,
        dateRange: '',
        isPressable: true,
        patientId: visit?.patient,
        onClick: () => {
          if (visitSummary.length !== 0) {
            let visitSummaryFile = visitSummary.filter(
              item => item.medical_record === visit?.recordId
            )
            if (visitSummaryFile.length !== 0) {
              let fileId = visitSummaryFile[0].id
              dispatch(
                Actions.createAction(
                  Actions.NAVIGATED_TO,
                  `${url}/visit-summary/${fileId}`
                )
              )
            } else {
              dispatch(
                Actions.createAction(Actions.PAST_VISIT_REQUESTED, {
                  recordId: visit.recordId,
                  url,
                })
              )
            }
          } else {
            dispatch(
              Actions.createAction(Actions.PAST_VISIT_REQUESTED, {
                recordId: visit.recordId,
                url,
              })
            )
          }
        },
      }
    })
    setPastVisitList(data)
  }, [pastVisits])

  return (
    <div className="past-visits">
      <Switch>
        <Route exact path={path}>
          <Page title={$t('sideMenu.pastVisits')} displayManageFamily>
            <ListView
              dataName="past-visit"
              data={pastVisitList}
              isLoading={isLoading}
              category={$t('sideMenu.pastVisits').toLowerCase()}
            />
          </Page>
        </Route>
        {VISIT_SUMMARY_FLAG ? (
          <Route path={`${path}/visit-summary/:fileId`}>
            <FilePreviewPage />
          </Route>
        ) : null}
        <Route path={`${path}/:fileId`}>
          <PastVisit />
        </Route>
      </Switch>
    </div>
  )
}

export default PastVisits
